import React from 'react';
import { useTranslation } from 'react-i18next';

import { LocationNotice, LocationNoticeButton } from '../styles';
import type { CaptureLocationStatus } from '../useCaptureLocation';

const TEXT_KEY: Partial<Record<CaptureLocationStatus, string>> = {
  'no-permission': 'modals:camera.noLocationPermission',
  askable: 'modals:camera.noLocation',
  blocked: 'modals:camera.locationBlocked',
  'no-signal': 'modals:camera.noLocationSignal',
};

interface LocationNoticeBannerProps {
  status: CaptureLocationStatus;
  /** Vuelve a pedir la ubicación (solo web, estado `askable`). */
  onAsk: () => void;
}

/**
 * Aviso de que la PRÓXIMA foto no llevará ubicación (spec fotos
 * geolocalizadas, § 15). Nunca frena el disparo.
 *
 * 🔴 Si en la web la ubicación está sin decidir, lleva un botón para volver a
 * pedirla. La cámara no insiste sola (se pregunta solo la primera vez), pero
 * sin botón el operario se quedaba sin salida: Chrome no lista un permiso sin
 * decidir en sus ajustes del sitio, así que no había dónde activarla (visto en
 * la tablet el 25-09-2026). Si está bloqueada, ya no se puede preguntar y el
 * aviso dice dónde desbloquearla.
 */
export const LocationNoticeBanner = ({
  status,
  onAsk,
}: LocationNoticeBannerProps): JSX.Element | null => {
  const { t } = useTranslation();
  const key = TEXT_KEY[status];
  if (!key) return null;

  return (
    <LocationNotice role="status">
      {t(key)}
      {status === 'askable' && (
        <LocationNoticeButton type="button" onClick={onAsk}>
          {t('modals:camera.enableLocation')}
        </LocationNoticeButton>
      )}
    </LocationNotice>
  );
};

export default LocationNoticeBanner;
